import React from "react";
import framing1Climb from "./assets/Framing_1_climb.jpg";
import framing1Pool from "./assets/Framing_1_pool.jpg";
import { Card } from "@blueprintjs/core";
import { ScreenProps } from "../../SequenceController";
import { useLanguage } from "../../../../context/LanguageContext";
import { colors, commonStyles } from "../../../../components/colors";

export const FramingScreen1 = (props: ScreenProps) => {
    const { t, language } = useLanguage();

    const title = t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'title') ||
        (language === 'en' ? "Decision at the Pool or Climbing Park" : "Die Entscheidung: Pool oder Kletterpark");

    return (
        <div className="experiment-container" style={commonStyles.container}>
            <div style={{ ...commonStyles.card, maxWidth: 880, margin: "0 auto", padding: 36 }}>
                <h2 style={{
                    color: colors.brillantBlue,
                    margin: "0 0 26px 0",
                    fontSize: 28,
                    fontWeight: 700,
                    textAlign: "center",
                    letterSpacing: 0.5
                }}>
                    {title}
                </h2>
                <div style={{
                    ...commonStyles.paragraph,
                    fontSize: 17,
                    color: colors.textDark,
                    margin: "0 0 18px 0",
                    textAlign: "justify"
                }}>
                    <p>{t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'content1')}</p>
                </div>
                <div className="image-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '28px',
                    margin: "32px 0"
                }}>
                    <Card style={{
                        maxWidth: 320,
                        padding: "18px 18px 12px 18px",
                        background: colors.backgroundLight,
                        boxShadow: "0 4px 14px 0 rgba(0,0,0,0.08)",
                        borderRadius: 14,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        <img
                            src={framing1Pool}
                            alt={t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'imgAltPool')}
                            style={{
                                width: "100%",
                                maxWidth: 260,
                                height: "auto",
                                borderRadius: 9,
                                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)"
                            }}
                        />
                        <p className="image-caption" style={{
                            textAlign: 'center',
                            color: colors.textDark,
                            fontSize: 17,
                            margin: "13px 0 0 0",
                            fontWeight: 400,
                            lineHeight: 1.7
                        }}>
                            {t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'imgCaptionPool')}
                        </p>
                    </Card>
                    <Card style={{
                        maxWidth: 320,
                        padding: "18px 18px 12px 18px",
                        background: colors.backgroundLight,
                        boxShadow: "0 4px 14px 0 rgba(0,0,0,0.08)",
                        borderRadius: 14,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        <img
                            src={framing1Climb}
                            alt={t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'imgAltClimb')}
                            style={{
                                width: "100%",
                                maxWidth: 260,
                                height: "auto",
                                borderRadius: 9,
                                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)"
                            }}
                        />
                        <p className="image-caption" style={{
                            textAlign: 'center',
                            color: colors.textDark,
                            fontSize: 17,
                            margin: "13px 0 0 0",
                            fontWeight: 400,
                            lineHeight: 1.7
                        }}>
                            {t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'imgCaptionClimb')}
                        </p>
                    </Card>
                </div>
                <div style={{
                    fontSize: 17,
                    color: colors.textDark,
                    marginBottom: 10,
                    textAlign: "justify",
                    lineHeight: 1.7
                }}>
                    <p>{t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'content2')}</p>
                    <p>{t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'content3')}</p>
                </div>
                <div className="navigation-hint" style={{
                    background: colors.silverVeryLight,
                    borderRadius: 8,
                    padding: "10px 18px",
                    marginTop: 22,
                    color: colors.textMedium,
                    fontSize: 15,
                    textAlign: "center",
                    fontStyle: "italic"
                }}>
                    {t('experiments', 'RiskyChoiceFraming', 'screens', 'screen1', 'continueHint')}
                </div>
            </div>
        </div>
    );
};